import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

  const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    _: RouterStateSnapshot,
    authData: AuthGuardData
    ): Promise<boolean | UrlTree> => {
      const { authenticated, grantedRoles } = authData;

      const hasExternalAccess = Object.values(grantedRoles.resourceRoles).some((userRoles) =>
        userRoles.includes('ATS__PARTNERS_ACCESS')
      );

      if (hasExternalAccess) {
        return true;
      } else return false;
    };

export const canActivateExternalRole = createAuthGuard<CanActivateFn>(isAccessAllowed);